var styleDataHash = '938dcc6a';  
export const injectCss = (() => {
  var css = `.AUfP-{height:100%;position:relative}.AUfP-:before{display:block;height:0;position:absolute;top:30%;width:100%}[dir] .AUfP-:before{margin:0 auto;text-align:center}[dir=ltr] .AUfP-:before{left:50%;transform:translate(-50%,-50%)}[dir=rtl] .AUfP-:before{right:50%;transform:translate(50%,-50%)}`;
  var isTest = typeof process !== 'undefined' && process.env && process.env['NODE_ENV'] === 'test';

  if (isTest || !css || typeof document === 'undefined') { return; }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.setAttribute('data-ricos-style-hash', styleDataHash);
  style.type = 'text/css';

  head.appendChild(style);

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});

injectCss();



export default {
  "alignCenter": "AUfP-"
};